<template>
    <div>
        <div style="max-height: 600px;">
<!--            <el-button type="text" v-if="canaddhalf" class="plus" @click="addhalf">{{!more?'+添加假别':'取消'}}</el-button>-->
            <div v-for="(leave,i) in leaveList">

                <div  class="datebox">
<!--                    <span class="datetxt" v-if="leaveList.length==2">{{leave.date+leave.duan}}</span>-->
                    <span class="datetxt">假别名称:</span>
                    <el-select  class="inputwidth"  v-model="leave.jbId" placeholder="请选择" @change="jbchange(leave.jbId,i)" :disabled="leaveper.type!=='new'&&leave.isbuka&&leave.jbString=='补打卡'" v-if="leaveper.type=='new'||leave.canjbid">
                        <el-option v-for="val in jbList"  :label="val.jbString" :value="val.jbId" :disabled="val.type==5||val.type==4"></el-option>
               </el-select>
                    <span v-if="leaveper.type!=='new'&&!leave.canjbid">{{leave.jbString}} </span>
                    <el-button type="text" class="datetxt ml20" v-if="leave.type==5" @click="buka(leave,i,'ka')">补卡</el-button>
                    <el-button type="text" class="datetxt ml20" v-if="leave.type==5" @click="buka(leave,i,'jia')">补假</el-button>
                </div>

                <div v-for="(dateinfo,index) in leave.list"  :key="index+'s'" class="datebox ">
                    <span class="datetxt" >{{dateinfo.date}}</span>
                    <span class="datetxt" >{{dateinfo.gs==0?'上半工时':'下半工时'}}</span>
                    <el-button type="text" class="datetxt ml20"
                               v-if="leave.vc_unit=='时'&&leave.showmore==0&&leave.jbString!=='加班'" @click="showclzz(dateinfo,index,leave)">
                        {{dateinfo.zdinvalid?'收起':'指定时段'}}
                    </el-button>
                        <el-radio-group v-model="dateinfo.i_invalid_type" class="checkbox ml20"  @change="showdateBtn"
                             v-if="dateinfo.zdinvalid||(leaveper.type!=='new'&&dateinfo.i_invalid_type)">
                            <el-radio :label="1"  @click.native.prevent="clickitem(dateinfo,1,'i_invalid_type')">迟来</el-radio>
                            <el-radio :label="2"  @click.native.prevent="clickitem(dateinfo,2,'i_invalid_type')">早走</el-radio>
                            <el-radio :label="3"  @click.native.prevent="clickitem(dateinfo,3,'i_invalid_type')">途中</el-radio>
                        </el-radio-group>
                        <div v-if="(leave.jbString=='调休'&&leave.showmore==0)||dateinfo.zdinvalid||(leaveper.type!=='new'&&dateinfo.i_invalid_type)" class=" dateinput flex">
                            <span class="datetxt">时长</span>
                            <el-input class="inputwidth sc"  v-model="dateinfo.overtimeHour"  @input="showdateBtn">
                            </el-input>{{leave.vc_unit}}
                        </div>
                    <div class=" dateinput flex" v-if="leave.jbString=='加班'" >
<!--                        <span class="datetxt">时间段</span>-->
                        <el-time-picker
                         @input="showdateBtn"
                            is-range
                            class="sjd"
                            value-format="HH:mm"
                            format="HH:mm"
                            v-model="dateinfo.sd"
                            range-separator="至"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            placeholder="选择时间范围">
                          </el-time-picker>
    <!--                    <el-input v-model="shiduan[index]" @change="jbsc(index)" class="sjd" ></el-input>-->
                        <span class="datetxt">时长</span>
                        <el-input v-model="dateinfo.overtimeHour"class="sc"  @input="showdateBtn"></el-input>
                        <span>{{leave.vc_unit}}</span>
                    </div>
                </div>

                <div>
<!--                    <div class=" datebox">-->
<!--                        <span class="datetxt">年假时间</span>-->
<!--                        <el-input class="inputwidth "  v-model="leave.overtimeHour"  @input="showdateBtn">-->
<!--                        </el-input>天-->
<!--                        <div v-if="leave.num!==undefined" ><span class="datetxt">剩余年假：</span>{{leave.num+'天'}}</div>-->
<!--                    </div >-->
                    <div v-if="leave.jbString=='调休'||leave.jbString=='年假'" class=" datebox">
                        <div class=" datebox"v-if="leave.showmore==1&&leave.jbString=='调休'" >
                            <span class="datetxt ">{{leave.jbString+'时间'}}</span>
                            <el-input class="inputwidth" v-model="leave.overtimeHour"  @input="showdateBtn">
                            </el-input>{{leave.vc_unit}}
                        </div>
                        <span class="datetxt "v-if="leave.num!==undefined">{{'剩余'+leave.jbString}}：<span>{{leave.num}}{{leave.jbString=='年假'?'天':leave.vc_unit}}</span></span>
                    </div>
                    <div v-if="leave.jbString=='加班'" style="margin-bottom: 22px;">
                        <div class="flex datebox">
                            <span class="datetxt ">加班类型</span>
                            <el-radio-group v-model="leave.overtimeType"  @input="showdateBtn">
                                <el-radio  :label="1">带薪加班</el-radio>
                                <el-radio  :label="2">可调休加班</el-radio>
                            </el-radio-group>
                        </div>
                        <div class="flex">
                            <span class="datetxt ">打卡校验</span>
                            <el-radio-group v-model="leave.i_overtime_verify" @input="dakaChange">
                                <el-radio  :label="1">是</el-radio>
                                <el-radio  :label="2">否</el-radio>
                            </el-radio-group>
                        </div>
                    </div>
                </div>
                <div>
                    <span class="datetxt ">文件上传</span>
                    <div class="upload">
                        <input type="file" name="files" value="" id="uploadfile1"
                         class="upload-input uploadfile1" @change="uploadFile1($event,i)"  >
                    </div>
                    <div>
                        <div v-for="(file,fi) in leave.filesImgList" class="upImg" :key="fi+'f'">
                            <a mce_href="#"
                               :href="file_url+'param='+encodeURI('{app:\''+baseApp+'\',i_uid:\''+i_uid+'\',token:\''+token+'\',version:\''+baseVersion+'\',fid:\''+file.filenewname+'\'}','utf-8')"
                               :download="file.filename"
                               style="color: skyblue;text-decoration: none">{{file.filename}}</a>
                            <el-button type="text" icon="el-icon-circle-close" class="delete" @click="deletefile(i,fi)"></el-button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="center">
                <el-button type="primary" :class="baseerp+'btn'"  @click="confirm" :disabled="dissavebtn">{{$t('button_confirm')}}</el-button>
                <el-button type="primary" :class="baseerp+'btn'"  @click="closenow" :disabled="disbtn">取消</el-button>
            </div>
        </div>

    </div>
</template>

<script>
    import * as API from "../api"
    import {baseerp,baseVersion,file_url,baseApp} from "@/utils/baseUrl";
    import {list} from "../../../archiveManage/dcsDetail/api";
    export default {
        name: "JiaBie",
        components: {},
        props:{
            leaveper:{
                type:Object,
                required:true
            },
            dateList:{
                type:Array,
                default:()=>[],
            }
        },
        watch:{
            dateList:{
                handler(){
                    if (this.dateList.length>0){
                        this.yearDate=this.dateList[0]
                        // console.log(this.leaveper,'this.leaveper')
                        if(this.leaveper.type=='new'){
                            this.leaveList[0]={"list":[],'filesImgList':[],'files':[],delSubs:[]}
                            this.canaddhalf=false
                            if( this.leaveper.shift=='shift'){
                                this.leaveList[0].showmore=1
                                this.leaveList[0].list.push({'date':this.dateList[0]})
                                this.leaveList[0].list.push({'date':this.dateList[this.dateList.length-1]})
                            }else {
                                this.leaveList[0].showmore=0
                                this.dateList.map(day=>{
                                    this.leaveList[0].list.push({'date':day})
                                })
                                if(this.dateList.length==1){
                                    this.canaddhalf=true
                                }
                            }

                        }
                        this.getJqDetailList()
                        // console.log(this.yearDate,'this.yearDate')
                    }
                },
                immediate: true,
                deep: true
            },
            leaveper:{
                handler(){
                    if (this.leaveper.type=='calender'||this.leaveper.type=='list'){
                        this.detail()
                    }
                    if(this.leaveper.type=='new'){
                        this.leaveList[0]={"list":[],'filesImgList':[],'files':[],delSubs:[]}
                        this.canaddhalf=false
                        if( this.leaveper.shift=='shift'){
                            this.leaveList[0].showmore=1
                            this.leaveList[0].list.push({'date':this.dateList[0]})
                            this.leaveList[0].list.push({'date':this.dateList[this.dateList.length-1]})
                        }else {
                            this.leaveList[0].showmore=0
                            this.dateList.map(day=>{
                                this.leaveList[0].list.push({'date':day})
                            })
                            if(this.dateList.length==1){
                                this.canaddhalf=true
                            }
                        }

                    }
                },
                immediate: true,
                deep: true
            },
        },
        data() {
            return {
                file_url:'',
                baseApp:'',
                baseVersion:'',
                token:"",
                delSubs:[],
                filesList:[],
                filesImgList:[],
                nochoose:false,
                showmore:'2',
                disbtn:false,
                dissavebtn:false,
                datepicker:'',
                baseerp:'',
                overtimeType: null,
                i_overtime_verify: null,
                showdateList:[],
                gsList:[],
                overtimeHour:null,
                jbvalue:'',
                jbname:'',
                jbList:[],
                shichang:[],
                shiduan:[],
                sub:[],
                lastNum: '',
                leaveList:[],
                oneday:{},
                more:false,
                canaddhalf:false,
                lianxu:true,
            }
        },
        mounted() {
            this.baseerp=baseerp
            this.baseVersion = baseVersion;
            this.baseApp = baseApp;
            this.file_url = file_url;
            this.token=sessionStorage.getItem('token');
            this.i_uid=sessionStorage.getItem('userid');

            // console.log(this.dateList,'this.dateList')
        },
        methods: {
            async uploadFile1(e,index=0) {
                let that = this;
                let i = 0;
                let $files = e.target.files[0];
                let fileName = $files.name;
                let type = $files.type;
                var list = {
                    "image/jpeg": true,
                    "image/png": true,
                    "image/jpg": true,
                    "image/bmp": true,
                    "application/pdf": true
                };
                let result = list[type];
                // if(($files && result==false) || ($files &&result==undefined)){
                //     that.$message.error('请上传格式正确的文件');
                //     return;
                // };
                if ($files) {
                    that.fileName = $files.name;
                    that.fileType = $files.type;
                    that.fileUrl = window.URL.createObjectURL(e.target.files[0]);
                } else {
                    that.fileName = "";
                    that.fileType = "";
                    that.fileUrl = "";
                }
                if (that.fileName) {
                    var fileId = 'uploadfile' + that.idNum;
                    var param = {
                        // "file": fileId,
                        // "fileName": that.fileName,
                        // "IDtype": "",
                        // "type": 1,
                        "style": "attendence",
                        "files": $files,
                        //"token":sessionStorage.getItem("token"),
                        //"app": "dsmanage",
                        "vc_app": "attendence",
                        "i_appid": 0,
                        // "version": "1.0",
                        // "i_uid": sessionStorage.getItem("userid"),
                        "vc_lruname":  sessionStorage.getItem("userid"),
                        "i_lruid": sessionStorage.getItem("userid"),
                        // "i_mid": this.mid
                    };
                    let FD = new FormData();
                    for (let key in param) {
                        FD.append(key, param[key])
                    }
                    let res = await API.uploadFile(param);
                    if (res.code == 1) {
                        // this.filesImgList.push(res.data[0])
                        // this.filesList.push(res.data[0].i_id)
                        if (this.leaveList.length>0){
                            this.leaveList[index].files.push(res.data[0].i_id)
                            this.leaveList[index].filesImgList.push(res.data[0])
                        }
                        this.$forceUpdate()

                        // console.log(this.leaveList[index])
                    } else if (res.code == -2) {
                        this.$router.push('/login');
                        this.$message.error(res.message);
                    } else {
                        this.$message.error(res.message);
                    }
                }
            },
            deletefile(i,fi){
                this.leaveList[i].files.splice(fi,1)
                this.leaveList[i].filesImgList.splice(fi,1)
                this.$forceUpdate()

            },
            showdateBtn(){
                this.$forceUpdate()
            },
            moreDay(val,i){
                this.leaveList[0].list=[]
                if (!val){
                    this.dateList.map(day=>{
                        this.leaveList[i].list.push({'date':day})
                    })
                }
                else{
                    this.leaveList[i].list.push({'date':this.dateList[0]})
                    this.leaveList[i].list.push({'date':this.dateList[this.dateList.length-1]})
                }
                this.$forceUpdate()
            },
            dakaChange(){
                this.$forceUpdate()
            },
            clickitem(val,label,name){
                label ===  val[name] ?  val[name] = '' :  val[name] = label
                this.$forceUpdate()
            },
            async getJqDetailList() {
                let params ={
                    startDate:this.yearDate,
                    endDate:this.yearDate,
                    userId:this.leaveper.id,
                }
                // console.log(params)
                let res = await API.getJqDetailList(params);
                if (res.code == 1) {
                    this.jbList = res.data
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },

            async detail() {
                let res;
                this.typeList=[];
                if (this.leaveper.type=='list'){
                    this.getuserInfo()
                    let params = {
                        id:this.leaveper.addId,
                    };
                    // console.log(params)
                    res = await API.detail(params);
                }else if (this.leaveper.type=='calender'){
                    let params = {
                        i_type:1,
                        userId:this.leaveper.id,
                        dateArr:this.dateList,

                        // forDate:this.dateList[0],
                        // startTime:this.dateList[0],
                        // endTime:this.dateList[this.dateList.length-1]
                    }
                    // console.log(params)
                    res = await API.dailyDetail(params);
                }
                if (res.code == 1) {
                    this.leaveList = res.data
                    this.leaveList.map((one)=>{
                        one.filesImgList=one.files
                        one.files=[]
                        one.filesImgList.map(f=>{
                            one.files.push(f.fileId)
                        })
                        one.canjbid=false
                        // if (one.type==5){one.canjbid=true}
                        this.typeList.push(one.type)
                        one.list=[]
                        if (one.jbString=="加班"){one.showmore=0}
                        one.sub.map((two)=> {
                            if (one.jbString == "调休" && one.sub.length == 1) one.overtimeHour = two.overtimeHour
                            let starti = two.startTime.indexOf(' '),
                                endi = two.endTime.indexOf(' '),
                                startDate = two.startTime.slice(0, starti),
                                hash = {},
                                endDate = two.endTime.slice(0, endi);
                            one.vc_unit = two.vc_unit
                            if (one.isrepair==0){
                                if (startDate == endDate) {
                                    one.showmore = 0
                                    if (this.leaveList.length == 2) {
                                        this.more = true
                                    } else if (this.leaveList.length == 1 && one.sub.length == 1) {
                                        if (two.startWhichHalf == 0 || two.startWhichHalf == 1) {
                                            this.canaddhalf = true
                                        } else {
                                            this.canaddhalf = false
                                        }
                                    }
                                    hash.subId = two.subId
                                    hash.jbId = two.jbId
                                    hash.date = startDate
                                    hash.gs = two.startWhichHalf
                                    hash.jbString = two.jbString
                                    hash.i_edit_type = two.i_edit_type
                                    hash.type = two.type
                                    one.i_edit_type = two.i_edit_type
                                    one.type = two.type

                                    hash.i_invalid_type = two.i_invalid_type
                                    if (hash.i_invalid_type) hash.zdinvalid = true
                                    if (two.jbString == "加班") {
                                        let stime = two.startTime.substr(starti + 1),
                                            etime = two.endTime.substr(starti + 1),
                                            si = stime.indexOf(':'),
                                            ei = stime.indexOf(':'),
                                            arr = startDate.split('-'),
                                            y = arr[0],
                                            m = arr[1],
                                            d = arr[2],
                                            sh = stime.slice(0, si),
                                            eh = etime.slice(0, ei),
                                            sm = stime.substr(si + 1),
                                            em = etime.substr(ei + 1);
                                        hash.sd = [new Date(y, m, d, sh, sm), new Date(y, m, d, eh, em)]
                                        // console.log(stime, sh, sm,'111',etime, eh, em)
                                        one.overtimeType = two.overtimeType
                                        hash.overtimeType = two.overtimeType
                                        hash.overtimeHour = two.overtimeHour
                                        one.i_overtime_verify = two.i_overtime_verify
                                        hash.i_overtime_verify = two.i_overtime_verify
                                    }
                                    hash.overtimeHour = two.overtimeHour
                                    one.list.push(hash)
                                } else {
                                    let s = {}, e = {};
                                    s.date = startDate
                                    s.gs = two.startWhichHalf
                                    s.subId = two.subId
                                    s.jbId = two.jbId
                                    s.jbString = two.jbString
                                    s.i_edit_type = two.i_edit_type

                                    s.overtimeType = two.overtimeType
                                    s.overtimeHour = two.overtimeHour

                                    s.i_overtime_verify = two.i_overtime_verify
                                    e.gs = two.endWhichHalf
                                    e.date = endDate
                                    e.subId = two.subId
                                    e.jbId = two.jbId
                                    e.jbString = two.jbString
                                    e.i_edit_type = two.i_edit_type

                                    e.overtimeHour = two.overtimeHour

                                    e.overtimeType = two.overtimeType
                                    e.i_overtime_verify = two.i_overtime_verify
                                    one.i_edit_type = two.i_edit_type
                                    one.type = two.type
                                    one.list.push(s)
                                    one.list.push(e)
                                    one.showmore = 1
                                    this.dissavebtn=true
                                    // console.log(one)
                                }
                            }else if (one.isrepair==1){
                                one.showmore = 0
                                if (this.leaveList.length == 2) {
                                    this.more = true
                                } else if (this.leaveList.length == 1 && one.sub.length == 1) {
                                    if (two.startWhichHalf == 0 || two.startWhichHalf == 1) {
                                        this.canaddhalf = true
                                    } else {
                                        this.canaddhalf = false
                                    }
                                }
                                hash.subId = two.subId
                                hash.jbId = two.jbId
                                hash.date = two.forDate
                                hash.gs = two.startWhichHalf
                                hash.jbString = two.jbString
                                hash.i_edit_type = two.i_edit_type
                                hash.type = two.type
                                one.i_edit_type = two.i_edit_type
                                one.type = two.type

                                hash.i_invalid_type = two.i_invalid_type
                                if (hash.i_invalid_type) hash.zdinvalid = true
                                if (two.jbString == "加班") {
                                    let stime = two.startTime.substr(starti + 1),
                                        etime = two.endTime.substr(starti + 1),
                                        si = stime.indexOf(':'),
                                        ei = stime.indexOf(':'),
                                        arr = startDate.split('-'),
                                        y = arr[0],
                                        m = arr[1],
                                        d = arr[2],
                                        sh = stime.slice(0, si),
                                        eh = etime.slice(0, ei),
                                        sm = stime.substr(si + 1),
                                        em = etime.substr(ei + 1);
                                    hash.sd = [new Date(y, m, d, sh, sm), new Date(y, m, d, eh, em)]
                                    // console.log(stime, sh, sm,'111',etime, eh, em)
                                    one.overtimeType = two.overtimeType
                                    hash.overtimeType = two.overtimeType
                                    hash.overtimeHour = two.overtimeHour
                                    one.i_overtime_verify = two.i_overtime_verify
                                    hash.i_overtime_verify = two.i_overtime_verify
                                }
                                hash.overtimeHour = two.overtimeHour
                                one.list.push(hash)
                            }
                        })
                    })
                    this.leaveList=this.leaveList.filter(l=>l.isrepair==1)
                    // console.log( this.leaveList,' this.leaveList')
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            async getuserInfo(){
                let param = {
                    userId: this.leaveper.id,
                }
                let res = await API.getuserInfo(param)
                if(res.code == 1){
                    // this.leaveper.unit = res.data.unit
                    this.leaveper.dt_upperstart=res.data.dt_upperstart
                    this.leaveper.dt_upperend=res.data.dt_upperend
                    this.leaveper.dt_lowerstart=res.data.dt_lowerstart
                    this.leaveper.dt_lowerend=res.data.dt_lowerend
                    this.leaveper.djmark=res.data.djmark
                }  else if(res.code == 0) {
                    this.$message.error(res.message);
                }
            },
            addhalf(){
                this.more=!this.more
                if (this.more){
                    this.leaveList.push({"list":[{'date':this.leaveList[0].list[0].date,"subId":0}],'filesImgList':[],'files':[],canjbid:true,id:0,showmore:0})
                }else{
                    this.leaveList.length=1
                }
            },
            showclzz(val,i,leave){
                val.zdinvalid=!val.zdinvalid
                if (!val.zdinvalid){
                    val.i_invalid_type=null
                    if (leave.jbString!='调休'){val.overtimeHour=null}
                }
                // this.more=val.zdinvalid
                this.$forceUpdate()
            },
            buka(val,i,type){
                if(type=='ka'){
                    this.leaveList[i].canjbid=true
                    let obj= this.jbList.find(one=>one.jbString=='补打卡')
                    this.leaveList[i].type=obj.type
                    this.leaveList[i].i_edit_type=obj.i_edit_type
                    this.leaveList[i].num=obj.num
                    this.leaveList[i].jbString=obj.jbString
                    this.leaveList[i].jbId=obj.jbId
                    this.leaveList[i].isbuka=true
                }else{
                    this.leaveList[i].canjbid=true
                    this.leaveList[i].type=null
                    this.leaveList[i].i_edit_type=null
                    this.leaveList[i].num=null
                    this.leaveList[i].jbString=null
                    this.leaveList[i].jbId=null
                    this.leaveList[i].isbuka=true
                }

                this.$forceUpdate()
            },

            jbchange(val,i){
                let obj= this.jbList.find(one=>one.jbId==val)
                this.leaveList[i].type=obj.type
                this.leaveList[i].i_edit_type=obj.i_edit_type
                this.leaveList[i].num=obj.num
                this.leaveList[i].jbString=obj.jbString
                this.leaveList[i].vc_unit=obj.vc_unit
                if ( obj.jbString=='加班'){
                    this.leaveList[i].i_overtime_verify=2
                    this.leaveList[i].overtimeType=2
                    this.leaveList[i].showmore=0
                    this.lianxu=false
                }else {
                    this.leaveList[i].showmore=this.leaveper.shift=='shift'?1:0
                    this.leaveList[i].i_overtime_verify=null
                    this.leaveList[i].overtimeType=null
                    this.lianxu=true
                }
                this.leaveList[i].list.map(one=>{
                    one.zdinvalid=false
                    one.zdinvalid=false
                    one.type=obj.type
                    one.i_edit_type=obj.i_edit_type
                    one.num=obj.num
                    one.jbString=obj.jbString
                    one.vc_unit=obj.vc_unit
                    one.jbId=obj.jbId
                })
                if (this.leaveper.type=='new'&&this.leaveper.shift=='shift'){
                    this.leaveList[i].list=[]
                    if (this.leaveList[i].showmore==0){
                        this.dateList.map(day=>{
                            this.leaveList[i].list.push({'date':day})
                        })
                    }else if (this.leaveList[i].showmore==1){
                        this.leaveList[i].list.push({'date':this.dateList[0]})
                        this.leaveList[i].list.push({'date':this.dateList[this.dateList.length-1]})
                    }
                    // console.log(this.leaveList)
                }

                this.$forceUpdate()
            },
            confirm(){

                let arr=[],delSubs=[],addData={};
                this.saveList=[];
                for (let i = 0; i < this.leaveList.length; i++) {
                    let leave=this.leaveList[i],
                        startdate = leave.list[0].date,
                        enddate = leave.list[leave.list.length - 1].date,
                        st =  leave.list[0].gs == 0 || leave.list[0].gs == 2 ? this.leaveper.dt_upperstart : this.leaveper.dt_lowerstart,
                        et =leave.list[leave.list.length-1].gs == 1 || leave.list[leave.list.length-1].gs == 2 ? this.leaveper.dt_lowerend : this.leaveper.dt_upperend;

                    // console.log(leave,'leave')
                    if (!leave.jbId){
                        this.$message.warning('请选择假别')
                        this.dissavebtn=false
                        this.disbtn=false
                        return
                    }
                    this.dissavebtn=true
                    this.disbtn=true
                    if (leave.showmore == 1) {
                        arr=[]
                        let hash = {
                            userName: this.leaveper.name,
                            userId: this.leaveper.id,
                            subId: 0,
                            i_isonlyday:st?0:1,
                            startTime: st?`${startdate} ${st}`:`${startdate} 00:00`,
                            endTime: et?`${enddate} ${et}`:`${enddate} 23:59`,
                            forDate:data.date,
                            startWhichHalf: leave.list[0].gs,
                            endWhichHalf: leave.list[leave.list.length-1].gs,
                            jbId: leave.jbId,
                            overtimeHour: leave.overtimeHour,
                            overtimeType: null,
                            i_overtime_verify: null,
                            djmark:this.leaveper.djmark,
                            type:leave.type,
                            i_edit_type:leave.i_edit_type
                        };
                        // console.log(leave,'hash')

                        arr.push(hash)
                    }else{
                        arr=[]
                        for (let j = 0; j < leave.list.length; j++) {
                            let data=leave.list[j],overtimeHour=leave.overtimeHour,
                                date=data.date,
                            startWhichHalf = (data.gs == 0 || data.gs == 1 ||data.gs == 2)?data.gs:null,
                            endWhichHalf =(data.gs == 0 || data.gs == 1 ||data.gs == 2)?data.gs:null,
                            startTime = (data.gs == 0 || data.gs == 2) ? this.leaveper.dt_upperstart : this.leaveper.dt_lowerstart,
                            endTime = (data.gs == 1 || data.gs == 2) ? this.leaveper.dt_lowerend : this.leaveper.dt_upperend;
                            if (leave.jbString == "加班") {
                                // let f=data.sd[0].toLocaleTimeString()
                                if(data.sd){
                                    startTime = typeof(data.sd[0])=='string'?data.sd[0]:data.sd[0].toLocaleTimeString().slice(0,5)
                                    endTime = typeof(data.sd[1])=='string'?data.sd[1]:data.sd[1].toLocaleTimeString().slice(0,5)
                                }else{
                                    startTime=null
                                    endTime=null
                                    data.overtimeHour=null
                                }
                                startWhichHalf = null;
                                endWhichHalf = null;
                            }
                            overtimeHour=data.overtimeHour?data.overtimeHour:null
                            let hash = {
                                userName: this.leaveper.name,
                                userId: this.leaveper.id,
                                subId: data.subId&&!leave.isbuka&&this.typeList[i]!==5?data.subId:0,
                                i_isonlyday:startTime?0:1,
                                startTime:startTime? `${date} ${startTime}`:`${date} 00:00`,
                                endTime:endTime? `${date} ${endTime}`:`${date} 23:59`,
                                forDate:data.date,
                                startWhichHalf: startWhichHalf,
                                endWhichHalf: endWhichHalf,
                                jbId:leave.jbId,
                                overtimeHour: overtimeHour,
                                i_invalid_type: data.i_invalid_type!==undefined?data.i_invalid_type:null,
                                overtimeType:  leave.overtimeType,
                                i_overtime_verify:  leave.i_overtime_verify,
                                djmark: this.leaveper.djmark,
                                type:leave.isbuka?leave.type:data.type?data.type:leave.type,
                                i_edit_type:data.i_edit_type?data.i_edit_type:leave.i_edit_type

                            };
                            // console.log(leave.type,'hash',data.type)
                            //
                            // return
                            if ((leave.jbString !== "加班"&&startWhichHalf!=null)||(leave.jbString == "加班"&&data.overtimeHour!=null))
                            {arr.push(hash)}
                        }
                    }
                    addData = {
                        userName: this.leaveper.name,
                        userId: this.leaveper.id,
                        startTime: arr[0].startTime,
                        endTime:  arr[arr.length-1].endTime,
                        jbName: leave.jbString,
                        jbId: leave.jbId,
                        type: leave.type,
                        i_edit_type: leave.i_edit_type,
                        creatorName: sessionStorage.getItem("lruname"),
                        creatorId: sessionStorage.getItem("userid"),
                        id: this.leaveper.type=='new'||leave.isbuka||this.typeList[i]==5?0:leave.id,
                        sub: arr,
                        repairIds: leave.isbuka?[leave.id]:[],
                        files:  leave.files,
                        isrepair: leave.isrepair,
                        delSubs: leave.delSubs,
                    };
                    this.saveList.push(addData)
                    // console.log(addData,'addData')

                }
                // console.log(this.saveList,'this.saveList')
                // return
                this.$confirm('是否确认保存', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.savemessage()
                }).catch(() => {
                    this.dissavebtn=false
                    this.disbtn=false
                    this.$message({
                        type: 'info',
                        message: '已取消保存'
                    })
                })

            },
            closenow(){
                // console.log(this.offsetovertime)
                // return
                this.$emit('close')
            },
            save(){
                this.disbtn=true
                this.dissavebtn=true
            },
            async savemessage() {
                let param = {
                    list:this.saveList
                };
                let res = await API.savemessage(param);
                if (res.code == 1) {
                    this.disbtn=false
                    this.dissavebtn=false
                    this.$emit('getshowForMonth')
                    this.$emit('close')
                    this.$message.success(res.message);

                } else if (res.code == -2) {
                    this.disbtn=false
                    this.dissavebtn=false
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.disbtn=false
                    this.dissavebtn=false
                    this.$message.error(res.message);
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .center{
        text-align: center;
    }
    .right{
        text-align: right;
    }
    .flex{
        display: flex;
    }
    .jcsb{
        justify-content: space-between;
    }
    .inputwidth{
        width:280px;
    }
    .dateinput{
        display: inline-block;
        margin-left: 20px;
        /*width:270px;*/

    }
    .sjd{
        width: 200px;
    }
    .sc{
        width: 70px;
    }
    .upload{
        display: inline-block;
        margin-left: 20px;
        width:70px;
        .el-input{
            width: 90%;
        }
    }
    .upload-input {

        width: 70px;

    }
    /*.upImg{*/
    /*    width: 70px;*/
    /*    height: 100px;*/
    /*    display: inline-block;*/
    /*    margin-right: 15px;*/
    /*    img{*/
    /*        width: 100%;*/
    /*        height: 100%;*/
    /*    }*/

    /*}*/
    .datebox{
        margin-bottom: 20px ;
    }
    .ml20{
        margin-left: 20px ;
    }
    .datetxt {
        padding-right: 10px;
        display: inline-block;
    }
    .plus{
        padding: 0 !important;
        font-size: 16px;
    }
    .delete{
        font-size: 14px;
        padding: 0 !important;
        display: inline-block;
        margin-left: 20px;
    }
</style>